module.exports = __webpack_public_path__ + "static/media/DwcImage.80210e41.webp";